import { createAction } from 'redux-actions'

export const SET_TAGS = createAction('SET_TAGS')
